// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__oO_eh","errors":"Errors_errors__7FDPL"};